import React from "react";

import MainLayout from "./Main";

import { IResourceLayoutProps } from "../../interfaces/resources";

import { TabContainer } from "../sub_components/Tabs";

export const ResourceDetailsLayout = (props: IResourceLayoutProps) => {
    const { title, error, children } = props;

    return (
        <MainLayout>
            <div className="immersion__common_details__layout">
                <div className="immersion__form_details__head">
                    <h2 className="color_dark">{title}</h2>
                </div>
                <div className="immersion__common_details__tabs__container">
                    <TabContainer
                        items={[{ id: "Details", label: "Details" }]}
                        activeTab={"Details"}
                        onChange={() => { }}
                        variant="navigation"
                    />
                </div>
                <div className="immersion__common_details__content">
                    {
                        error
                            ? <div className="immersion__common_details__error_view">
                                <br /><br />
                                <h4 className="color_dark text_center">Error occured while fetching the data.</h4>
                                <h4 className="color_dark text_center">Please try again later.</h4>
                            </div>
                            : children
                    }
                </div>
            </div>
        </MainLayout>
    );
};